/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import AdvancedHero from '../../components/heros/advanced';
import Location from '../../components/sections/location';
import Footer from '../../components/footer';
import Reviews from '../../components/sections/reviews';

const About = () => {
    return (
        <main>
            <AdvancedHero subtitle="About Us" title="Mission Statement" description="Since 2019, we've been focusing on providing high quality game servers at an affordable price. Our mission is to make the process as easy for you as possible by providing the right tools, the right support, and the right hardware to get the job done." />
            <section className='our-story max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-28'>
                <div className='primary-gradient px-16 rounded-md pt-20 pb-24'>
                    <div className='header mb-10'>
                        <h1 className='text-gray-100 text-3xl uppercase font-semibold'>Our Story</h1>
                    </div>
                    <div className='body'>
                        <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-y-8 gap-x-16'>
                            <div>
                                <p className='text-gray-300 text-lg'>Cyperhost is a Sweden based business created with the sole intention of bringing you high quality game servers at a low price point. Over the past 3 years we've been constantly revising our services to provide maximum value without cutting any corners.</p>
                            </div>
                            <div>
                                <p className='text-gray-300 text-lg'>Today, we're focused on transparency and customer support. In addition to the value pricing and high quality hardware, we're showing you what is under our hood on our <a href="https://status.cyperhost.com/" className='text-primary hover:underline'>status page</a>.</p>
                            </div>
                            <div>
                                <p className='text-gray-300 text-lg'>We have been fortunate enough to serve hundreds of clients and are constantly learning about ways that we can improve our services.</p>
                            </div>
                            <div>
                                <p className='text-gray-300 text-lg'>Truly great support is another focus of ours, you can always reach a real human being at any time via live chat or support tickets.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='stats py-28'>
                <div className='bg-altPrimary py-24'>
                    <div className='max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                        <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-x-5 gap-y-10'>
                            <div className='border-none sm:border-none md:border-none lg:border-solid border-r'>
                                <h1 className='text-center text-gray-100 text-4xl font-semibold mb-3.5'>1000+</h1>
                                <h2 className='text-center text-gray-300 text-2xl'>Clients Served</h2>
                            </div>
                            <div className='border-none sm:border-none md:border-none lg:border-solid border-r'>
                                <h1 className='text-center text-gray-100 text-4xl font-semibold mb-3.5'>3</h1>
                                <h2 className='text-center text-gray-300 text-2xl'>Server Locations</h2>
                            </div>
                            <div className='border-none sm:border-none md:border-none lg:border-solid border-r'>
                                <h1 className='text-center text-gray-100 text-4xl font-semibold mb-3.5'>550+</h1>
                                <h2 className='text-center text-gray-300 text-2xl'>Tickets Resolved</h2>
                            </div>
                            <div>
                                <h1 className='text-center text-gray-100 text-4xl font-semibold mb-3.5'>2000+</h1>
                                <h2 className='text-center text-gray-300 text-2xl'>Servers Deployed</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Location />
            <section className='our-timeline pt-28 pb-36 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Our Timeline</h1>
                    <p className="text-gray-300 text-center">Learn more about what we have gone through. Get to know Cyperhost more.</p>
                </div>
                <div className='body'>
                    <div className='grid grid-cols-7 gap-x-10 gap-y-0'>
                        {/* 2020 */}
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                            <h1 className='text-gray-100 text-4xl font-semibold'>2020</h1>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>August</h1>
                            <p className='text-gray-300 mb-0.5'>Pierce launched Cyperhost</p>
                            <p className='text-gray-300 mb-0.5'>Support team applications were deployed</p>
                            <p className='text-gray-300 mb-0.5'>Desktop Application for Cyperhost's panel launched</p>
                            <p className='text-gray-300 mb-0.5'>Jamie F joins Cyperhost</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>September</h1>
                            <p className='text-gray-300 mb-0.5'>Cyperhost updates their logo and banner</p>
                            <p className='text-gray-300 mb-0.5'>Website hosting launched</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>October</h1>
                            <p className='text-gray-300 mb-0.5'>New Website (Second website Design)</p>
                            <p className='text-gray-300 mb-0.5'>Android and IOS app officially launched</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>Novemember</h1>
                            <p className='text-gray-300 mb-0.5'>Updated Terms of Service & Privacy Policy</p>
                            <p className='text-gray-300 mb-0.5'>Partnership with MC-List announced.</p>
                            <p className='text-gray-300 mb-0.5'>Cyperhost released panel banners.</p>
                            <p className='text-gray-300 mb-0.5'>Cyperhost obtains their second dedicated server.</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>December</h1>
                            <p className='text-gray-300 mb-0.5'>New website design announced (Third website design)</p>
                            <p className='text-gray-300 mb-0.5'>Cyperhost merges with Pandora hosting</p>
                            <p className='text-gray-300 mb-0.5'>Cyperhost undergoes new ownership/management</p>
                            <p className='text-gray-300 mb-0.5'>Affiliate Program officially launched</p>
                        </div>
                        {/* 2021 */}
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary pt-9 pb-5'>
                            <h1 className='text-gray-100 text-4xl font-semibold'>2021</h1>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 pt-9 pb-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>January</h1>
                            <p className='text-gray-300 mb-0.5'>New UK location launched</p>
                            <p className='text-gray-300 mb-0.5'>Founder Pierce steps down</p>
                            <p className='text-gray-300 mb-0.5'>Co-owner Skyler steps down</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>February</h1>
                            <p className='text-gray-300 mb-0.5'>Cyperhost discontinues FiveM hosting</p>
                            <p className='text-gray-300 mb-0.5'>Cyperhost migrates to Plesk from cPanel</p>
                            <p className='text-gray-300 mb-0.5'>Jake P. joins Cyperhost</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>March</h1>
                            <p className='text-gray-300 mb-0.5'>Cyperhost launches there first blog</p>
                            <p className='text-gray-300 mb-0.5'>Virtual Private Servers launched</p>
                            <p className='text-gray-300 mb-0.5'>Ethan S. joins Cyperhost</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>April</h1>
                            <p className='text-gray-300 mb-0.5'>Cyperhost becomes one year old</p>
                            <p className='text-gray-300 mb-0.5'>Client area re-designed and launched</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>October</h1>
                            <p className='text-gray-300 mb-0.5'>Cyper panel redesign announced & launched</p>
                            <p className='text-gray-300 mb-0.5'>Partnership recruitment announced.</p>
                            <p className='text-gray-300 mb-0.5'>Cyperhost revamped bot announced</p>
                            <p className='text-gray-300 mb-0.5'>Reseller hosting announced & launched</p>
                        </div>
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary py-5'>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 py-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>December</h1>
                            <p className='text-gray-300 mb-0.5'>Budget Minecraft Hosting announced & launched</p>
                            <p className='text-gray-300 mb-0.5'>New EU location launched (Germany)</p>
                            <p className='text-gray-300 mb-0.5'>Virtual Private Servers discontinued.</p>
                        </div>
                        {/* 2022 */}
                        <div className='border-r-4 col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 border-altPrimary pt-9 pb-5'>
                            <h1 className='text-gray-100 text-4xl font-semibold'>2022</h1>
                        </div>
                        <div className='col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-6 pt-9 pb-5'>
                            <h1 className='text-gray-300 text-3xl font-semibold mb-2.5'>January</h1>
                            <p className='text-gray-300 mb-0.5'>New website designed (Fourth website design)</p>
                            <p className='text-gray-300 mb-0.5'>Cyper panel improved and introduced new features</p>
                            <p className='text-gray-300 mb-0.5'>Pierce G. re-joins Cyperhost</p>
                            <p className='text-gray-300 mb-0.5'>Rust hosting launched</p>
                            <p className='text-gray-300 mb-0.5'>Arma 3</p>
                        </div>
                    </div>
                </div>
            </section>
            <Reviews />
            <Footer />
        </main>
    )
}

export default About